import { EntityId } from "@bbwt/interfaces";

export class FormIOInboxItem {
    id: string;
    id_original: string;
    type: FormIOInboxItemType;
    name: string;
    requester: string;
    createdOn: Date
    completedOn: Date;
    complete: boolean;
    stages: string[];
    activeStage: string[];
    activeStageAssigneeId: string;
    nextStage: string;
    tags: FormInboxItemTag[];
    isArchived: boolean;
    formDefinitionId: string;
    formRevisionId: string;
    formRequestId? : string;
    surveyId?: string;
    episodeId?: string;
    mufId?: string;
    mufAssocId?: string;
    patientId?: string;
    patientName: string;
    isReadOnlyEpisode: boolean
}

export class FormInboxItemTag {
    id: EntityId;
    name: string;
}

export enum FormIOInboxItemType {
    Request,
    Survey,
    Form
}

export const FormIOInboxItemTypeMap: { [key: number]: string } = {};
FormIOInboxItemTypeMap[FormIOInboxItemType.Request] = "Request";
FormIOInboxItemTypeMap[FormIOInboxItemType.Survey] = "Survey";
FormIOInboxItemTypeMap[FormIOInboxItemType.Form] = "Form";
export const getFormIOInboxItemType = (itemType?: FormIOInboxItemType) => (itemType in FormIOInboxItemTypeMap ? FormIOInboxItemTypeMap[itemType] : "");